<template>
  <div class="p-5">
    <div class="flex justify-end" v-has-permission="'AssignDocument'">
      <a
        style="background-color: #14a577"
        class="flex items-center justify-center gap-4 w-48 h-10 rounded-lg text-white cursor-pointer mb-6"
        @click.prevent="uploadPopup = true"
      >
        {{ $t("UploadImage")
        }}<i class="material-icons notranslate"> cloud_upload </i>
      </a>
    </div>
    <data-grid
      ref="grid"
      stripe
      :data-source="gridDataSource"
      :search-data="gridSearchData"
      :columns="[{ title: 'مدرک' }, { title: 'تصویر' }, { title: 'عملیات' }]"
    >
      <template slot-scope="{ row }">
        <td style="width: 10%">
          {{ row.documentSettingName }}
        </td>
        <td style="width: 60%">
          <div class="w-full flex justify-center">
            <img
              :src="URLS_CONSTANTS.assets + 'SuppliersAttachments/' + row.document"
              style="max-height: 100px"
              class="rounded cursor-pointer"
              :alt="row.documentSettingName"
              @click.prevent="
                showImagePopup(
                  URLS_CONSTANTS.assets + 'SuppliersAttachments/' + row.document
                )
              "
            />
          </div>
        </td>
        <td style="width: 20%">
          <div
            @click="removeImage(row.document)"
            v-has-permission="'UnAssignDocument'"
          >
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              class="d-inline"
            ></vs-button>
          </div>
        </td>
      </template>
    </data-grid>
    <upload-popup
      :show="uploadPopup"
      @close="uploadPopup = false"
      @success="renderGrid"
      :documents="documents"
    >
    </upload-popup>
    <ImagePopup
      v-if="imagePopup"
      :show="imagePopup"
      :image="selectedImage"
      @close="imagePopup = false"
    ></ImagePopup>
  </div>
</template>

<script>
import { URLS_CONSTANTS } from "@/../config";
import myUpload from "vue-image-crop-upload";
import DataGrid from "@/components/datagrid/DataGrid";
import UploadPopup from "./UploadPopup.vue";
import ImagePopup from "./ImagePopup.vue";

import { mapActions } from "vuex";
export default {
  props: {
    mode: {
      required: true,
      value: ["legal", "individual"],
    },
  },
  data() {
    return {
      show: false,
      gridDataSource: {
        type: "app",
        service: `/BusinessParties/api/SuppliersQuery/${this.$route.params.id}`,
      },
      gridSearchData: {
        keyword: "",
      },
      selectedDocument: {
        id: null,
      },
      imageName: "",
      uploadPopup: false,
      documents: [],
      URLS_CONSTANTS,
      imagePopup: false,
      selectedImage: "",
    };
  },
  components: {
    "my-upload": myUpload,
    DataGrid,
    UploadPopup,
    ImagePopup,
  },
  mounted() {
    if (this.$tabHasPermission("GetDocumentSettingsByPartyType"))
      this.getData();
  },
  methods: {
    ...mapActions({
      postImage: "agentsDocumentUpload/uploadSupplierDocument",
      deleteImage: "agentsDocumentUpload/deleteSupplierDocuments",
      getDocumentSettings: "agentsDocumentUpload/getDocumentSettings",
    }),
    getData() {
      const partyType = this.$props.mode === "legal" ? 1 : 0;
      this.getDocumentSettings(partyType).then((res) => {
        let docs = [];
        for (let doc of res) {
          docs.push({
            id: doc.id,
            label: doc.name,
          });
        }
        this.documents = docs;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    removeImage(document) {
      const payload = {
        supplierId: this.$route.params.id,
        document,
      };
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.deleteImage(payload).then(() => {
            this.renderGrid();
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
          });
        }
      });
    },
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 500);
    },
    showImagePopup(image) {
      this.selectedImage = image;
      this.imagePopup = true;
    },
  },
};
</script>

<style scoped></style>
